import styled, { css } from 'styled-components';

import On from '../asset/check_on.png';
import Off from '../asset/check_off.png';

export const Wrap = styled.div`
  padding: 20px 16px;
  background-color: #FFFFFF;
  border: 1px solid #004AFF;
  border-radius: 16px;

  & + & {
    margin-top: 16px;
  }
`;

export const CheckboxWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;

  .checkbox-label {
    position: relative;
    display: flex;
    align-items: center;
    color: #484848;
    cursor: pointer;
    float: left;
    clear: both;
  }

  // ie input x 버튼 삭제
  input::-ms-clear {
    display: none;
  } 

  input[type='checkbox'] {
    margin: 0;
    border: 0;
    width: 0;
    height: 0;
    -webkit-appearance: none;
  }

  input[type='checkbox']:checked {
    margin: 0;
    border: 0;
    -webkit-appearance: none;
  } 

  //absolute로 보여지는 체크박스의 실체
  input[type='checkbox'] + span {
    width: 24px;
    height: 24px;
    margin-right: 4px;
    display: inline-block;
    flex-shrink: 0;
  }

  span + p {
    color: #0066EC;
    font-weight: 700;
    font-size: 16px;
    line-height: 26px;  
  }

  // + 연산자를 통해 input태그옆의 span 태그에 접근할수있다.
  input[type='checkbox'] + span::before {
    content: '';
    width: 24px;
    height: 24px;
    display: inline-table;
    border: 0;
    position: absolute;
    background-image: url(${Off});
    background-repeat: no-repeat;
    background-size: cover;
    top: 50%;
    transform: translateY(-50%);
  }

  input[type='checkbox']:checked + span::before {
    content: '';
    width: 24px;
    height: 24px;
    display: inline-table;
    border: 0;
    position: absolute;
    background-image: url(${On});
    background-repeat: no-repeat;
    background-size: cover;
    top: 50;
    transform: translateY(-50%);
  }
`;

export const ButtonWrap = styled.button`
  width: 24px;
  height: 24px;
  background-color: inherit;
  border: none;

  ${({ isCheck }) => isCheck ? css`
    transform: rotate(0deg);
    transition: transform 150ms ease;
    ` : css`
    transform: rotate(-180deg);
    transition: transform 150ms ease;
  `}
`;

export const TermsWrap = styled.ol`
  color: #656565;
  margin-top: 8px;
  list-style: decimal;
  list-style-position: outside;
  margin-left: 18px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
`;
